const Fetchdetails = async(api,postData) => {
    try{
      let url = `${api}`
      let response = await fetch(url,postData);
      let res = await response.json();
      return {'actionMsg':1,res};
    }
    catch(error){
      let Message = error.message || 'contact admin'
      return {'actionMsg':0,'Message':Message};
    }
  }
  
  export {Fetchdetails}